import {combineReducers} from "redux";

import todoSlice from "../actions/todoSlice";
import diarySlice from "../actions/diarySlice";
import activityLog from "../actions/activityLogSlice";
import auth from "../actions/authSlice.js";
import employeeNoteSlice from "../actions/employeeNoteSlice";
import listingSlice from "../actions/listingSlice";
import enquiryLogSlice from "../actions/enquiryLogSlice";
import {RESET_STATE} from "../Reset/reset";
import oneOnoneSlice from "../actions/oneOnoneSlice";
import prospectSlice from "../actions/prospectSlice";
import buyerSlice from "../actions/buyerSlice";
import openHomes from "../actions/openHome";
import customNoteSlice from "../actions/CustomNoteSlice.js";

const appReducer = combineReducers({
  auth,
  todo: todoSlice,
  diary: diarySlice,
  activityLog,
  employee: employeeNoteSlice,
  oneOnone: oneOnoneSlice,
  enquiry: enquiryLogSlice,
  listingSlice,
  prospectSlice,
  buyerSlice,
  openHomes,
  customNoteSlice,
});

const rootReducer = (state, action) => {
  if (action.type === RESET_STATE) {
    state = undefined;
  }

  return appReducer(state, action);
};

export default rootReducer;
